export default __webpack_public_path__ + "static/media/logo192.89cbeedc.png";